module.exports = __webpack_public_path__ + "static/icon3-diab-e53a3d9d2df9dfe2f1c53dda9823c1b5.png";